export enum Pagination {
  skip = 0,
  pageSize = 50,
  pageIndexDefault = 1,
  totalCountDefault = 0,
}
